export default () => ({
  smsCreatedInfo: undefined,
  validationSmsData: undefined,
  smsValidated: undefined,
  userNotFound: false,
  userIsBlocked: false,
});
